import { render, staticRenderFns } from "./ChangeFactory.vue?vue&type=template&id=f2ecc1be&"
import script from "./ChangeFactory.vue?vue&type=script&lang=js&"
export * from "./ChangeFactory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports